/* eslint-disable filenames/match-regex */

const support = process.env.VUE_APP_SUPPORT_BUILD == 1
  ? require('./support/real.js').default
  : require('./support/fake.js').default;

export { support as default };
